import type { RootState } from '@core/core/store'
import { createSelector } from '@reduxjs/toolkit'

import { selectCompanyById } from '../companies'
import { fieldsAdapter } from './fieldSlice'

const { selectAll } = fieldsAdapter.getSelectors<RootState>(state => state.fields)

export const selectAllFields = (state: RootState) => selectAll(state)

export const selectFieldsByCompany = createSelector(
  [selectCompanyById, selectAllFields],
  (company, fields) => {
    const ids = company?.fieldIds ?? []
    return ids.length > 0 ? fields.filter(field => ids.includes(field.id)) : []
  },
)
